<template>
  <WizardStep
    v-if="hasEditMerchantSettingsPermission"
    heading=""
    :hideFooter="true"
  >
    <template v-slot:content>
      <b-row v-for="(webhook, index) in webhooks" :key="index">
        <b-col class="web-hook-confirmation">
          <KTPortlet
            :id="`webhook-${index}`"
            :title="webhook.Name"
            :class="confirmwebhook"
          >
            <template v-slot:body>
              <WebhookForm v-model="endpoints[webhook.SK]" :event="webhook" />
            </template>
          </KTPortlet>
          <b-tooltip :target="`webhook-${index}`" triggers="hover">
            {{ webhook.Description }}
          </b-tooltip>
        </b-col>
      </b-row>
    </template>
  </WizardStep>
</template>

<script>
import WizardStep from "@/components/wizard/WizardStep";
import MerchantSettingsPermissionsMixin from "@/components/merchantsettings/MerchantSettingsPermissionsMixin.js";
import { API, graphqlOperation } from "aws-amplify";
import WebhookForm from "@/components/merchantsettings/webhooks/WebhookForm.vue";
import KTPortlet from "@/views/partials/content/Portlet";

export default {
  mixins: [MerchantSettingsPermissionsMixin],
  components: { WizardStep, WebhookForm, KTPortlet },
  props: ["heading"],
  data: () => {
    return {
      webhooks: [],
      endpoints: {},
      confirmwebhook: "confirm-webhook"
    };
  },
  methods: {
    async retrieveWebhooks() {
      try {
        const getAllWebhooks = `
              query GetAllWebhooks {
                  getAllWebhooks {
                    nextToken
                    webhooks {
                      Description
                      Example
                      Name
                      SK
                    }
                  }
              }
            `;
        const getAllWebhooksResponse = await API.graphql({
          ...graphqlOperation(getAllWebhooks)
        });

        return getAllWebhooksResponse.data.getAllWebhooks.webhooks;
      } catch (e) {
        this.$logger.error("Error retrieving webhook configuration");
        this.$logger.error(e);
      }
      return [];
    },
    async retrieveMerchantEndpoints() {
      try {
        const getMerchantWebhooks = `
              query GetMerchantWebhooks {
                  getMerchantWebhooks
              }
            `;
        const getMerchantWebhooksResponse = await API.graphql({
          ...graphqlOperation(getMerchantWebhooks)
        });

        return getMerchantWebhooksResponse.data.getMerchantWebhooks;
      } catch (e) {
        this.$logger.error("Error retrieving merchant endpoints");
        this.$logger.error(e);
      }
      return {
        standardTransaction: {
          endpoint: "",
          secret: "safas"
        },
        recurringTransaction: {
          endpoint: "",
          secret: ""
        }
      };
    },

    parseEndpointData(webhooks, endpoints) {
      try {
        endpoints = JSON.parse(endpoints);
      } catch (e) {
        this.$logger.error("Error parsing endpoints");
        this.$logger.error(endpoints);
        this.$logger.error(e);
        endpoints = {};
      }
      if (!endpoints) {
        endpoints = {};
      }

      webhooks.forEach(webhook => {
        const webhookName = webhook.SK;
        if (!endpoints[webhookName]) {
          endpoints[webhookName] = {
            endpoint: "",
            secret: ""
          };
        }
      });

      return endpoints;
    },
    async retrieveData() {
      const [webhooks, merchantEndpoints] = await Promise.all([
        this.retrieveWebhooks(),
        this.retrieveMerchantEndpoints()
      ]);
      this.webhooks = webhooks;
      this.endpoints = this.parseEndpointData(webhooks, merchantEndpoints);
    }
  },
  async mounted() {
    await this.retrieveData();
  }
};
</script>

<style lang="scss" scoped>
.confirm-webhook {
  max-width: 80%;
  box-shadow: none;
}

.web-hook-confirmation {
  display: flex;
  justify-content: center;
}

@media only screen and (max-width: 1024px) {
  .confirm-webhook {
    max-width: 100%;
    box-shadow: none;
  }
}
</style>
